<template>
  <div class="performance-goals">
    <div class="box-view">
      <el-button size="small" :type="currentView === 'table' ? 'primary' : 'default'" @click="currentView = 'table'">业绩设置</el-button>
      <el-button v-if="canViewChart" size="small" :type="currentView === 'summary' ? 'primary' : 'default'" @click="currentView = 'summary'">业绩图表</el-button>
    </div>
    <br>

    <template v-if="currentView === 'table'">
      <el-tabs class="performance-goals-tabs" v-model="activeTab" v-if="users.length">
        <el-tab-pane v-for="tab in tabs" :key="tab.key" :lazy="tab.lazy" :label="tab.label" :name="tab.key">
          <Table
            :users="users"
            :disabled="!canEdit"
            :mode="tab.key"
          />
        </el-tab-pane>
      </el-tabs>
    </template>

    <Summary v-if="currentView === 'summary'" :users="users" />
  </div>
</template>

<script>
import { Vue, Component, Mixins } from 'vue-property-decorator';
import Utils from '@/components/utils.vue';
import Table from './table.vue';
import { abilityService } from 'beans-admin-plugin';
import Summary from './summary.vue';

@Component({
  components: {
    Table,
    Summary,
  },
  props: {
    users: {
      type: Array,
      default: () => []
    }
  }
})
export default class PerformanceGoals extends Mixins(Vue, Utils) {
  currentView = 'table'; // summary, table

  activeTab = 'finish_target';

  get tabs() {
    return [
      {
        key: 'finish_target',
        label: '完结金额',
        if: this.performanceGoalTargets.includes('finish_target'),
      },
      {
        key: 'sales_target',
        label: '开单金额',
        if: this.performanceGoalTargets.includes('sales_target'),
      },
      {
        key: 'shipping_target',
        label: '出货金额',
        if: this.performanceGoalTargets.includes('shipping_target'),
      },
    ].filter(tab => tab.if);
  }

  get canViewChart() {
    return abilityService.can(['reports/sales_follows.read']);
  }

  get canEdit() {
    return abilityService.can(['performance_goals.update', 'performance_goals.create']);
  }

  created() {
    this.activeTab = this.tabs[0].key;
  }
}
</script>

<style lang="scss" scoped>
.performance-goals {
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.performance-goals-tabs {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  :deep(.el-tabs__content) {
    flex: 1;
    overflow: hidden;

    .el-tab-pane {
      height: 100%;
      overflow: hidden;
    }
  }
}
</style>
